<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Consult',
  }
</script>

<style scoped>
</style>